var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWildberries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 11.35c0-4.997 0-7.495 1.552-9.048C3.855.75 6.353.75 11.35.75h5.3c4.997 0 7.495 0 9.048 1.552 1.552 1.553 1.552 4.051 1.552 9.048v5.3c0 4.997 0 7.495-1.552 9.048-1.553 1.552-4.051 1.552-9.048 1.552h-5.3c-4.997 0-7.495 0-9.048-1.552C.75 24.145.75 21.647.75 16.65v-5.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 11.35c0-4.997 0-7.495 1.552-9.048C3.855.75 6.353.75 11.35.75h5.3c4.997 0 7.495 0 9.048 1.552 1.552 1.553 1.552 4.051 1.552 9.048v5.3c0 4.997 0 7.495-1.552 9.048-1.553 1.552-4.051 1.552-9.048 1.552h-5.3c-4.997 0-7.495 0-9.048-1.552C.75 24.145.75 21.647.75 16.65v-5.3z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86 19H5.367V8.497h4.39c1.994 0 3.195 1.005 3.195 2.62 0 1.107-.816 2.082-1.871 2.25v.13c1.412.132 2.387 1.15 2.387 2.519 0 1.841-1.368 2.984-3.61 2.984zM7.245 9.99v2.925H9.06c1.332 0 2.038-.516 2.038-1.463 0-.924-.663-1.463-1.798-1.463H7.246zm0 7.518H9.43c1.383 0 2.118-.568 2.118-1.638 0-1.048-.757-1.601-2.191-1.601h-2.11v3.239zm11.719.138c1.273 0 2.008-.91 2.008-2.504 0-1.528-.735-2.409-2.008-2.409-1.274 0-2.01.881-2.01 2.41 0 1.593.729 2.503 2.01 2.503zm-2.431-4.87h.123c.48-.894 1.354-1.498 2.671-1.498 2.082 0 3.501 1.448 3.501 3.828 0 2.511-1.47 4.054-3.843 4.054-2.46 0-3.886-1.565-3.886-4.767 0-3.938 1.164-5.932 4.185-6.049l.939-.036c1.237-.051 2.074-.357 2.081-.364v1.5s-.517.334-1.972.385l-.917.037c-2.024.08-2.664 1.091-2.883 2.91z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 15.325,
    y1: 22.613,
    x2: 10.025,
    y2: -0.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB4EC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.967,
    stopColor: "#FA3C96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWildberries);
export default __webpack_public_path__ + "static/media/wildberries.4a2d6c1788cee4eb96d894662f657e96.svg";
export { ForwardRef as ReactComponent };